import { Checkbox, Typography } from "antd";

interface IProps {
  agreePolicy: boolean;
  setAgreePolicy: (value: boolean) => void;
}

const PolicyAgreement = ({
  agreePolicy,
  setAgreePolicy
}: IProps) => {
  return (
    <div className="policy-agreement">
      <Typography.Text style={{fontWeight: 700}}>💡 안내 사항</Typography.Text>
      <div className="flex flex-vertical gap-17" style={{paddingLeft: 5}}>
        <Checkbox checked={agreePolicy} onChange={() => setAgreePolicy(!agreePolicy)} >(필수) 안내 사항을 모두 확인하였으며, 이에 동의합니다.</Checkbox>
        <ul>
          <li ><Typography.Text>Shopee 계정을 보유하고 계신 고객님께서는 Shopee 사이트에서 간단한 연동 절차를 거쳐, 버스크풀필먼트 서비스에서도 Shopee에서 들어오는 주문을 바로 확인하실 수 있습니다.<br/></Typography.Text></li>
          <li><Typography.Text>⚠️ 원활한 연동을 위해, 쇼피 사이트에서 Authorize Merchant의 체크박스가 활성화 되지 않도록 해주세요.</Typography.Text></li>
        </ul>
        <img src='/images/shopee-guide.jpg' alt='Shopee Guide'  style={{maxWidth: 1135}}/>
      </div>
    </div>
  );
} 

export default PolicyAgreement;